import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import { Editor } from 'slate';
import { ReactEditor } from '@seafile/slate-react';
var CheckListItem = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(CheckListItem, _React$PureComponent);
  var _super = _createSuper(CheckListItem);
  function CheckListItem() {
    var _this;
    _classCallCheck(this, CheckListItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.onChange = function (event) {
      var editor = _this.props.editor;
      var checked = event.target.checked;
      var path = ReactEditor.findPath(editor, _this.props.element);
      Editor.setNodes(editor, {
        data: {
          checked: checked
        }
      }, {
        at: path
      });
    };
    return _this;
  }
  _createClass(CheckListItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        attributes = _this$props.attributes,
        children = _this$props.children,
        element = _this$props.element;
      var checked = element.data.checked;
      return /*#__PURE__*/React.createElement("li", Object.assign({}, attributes, {
        className: 'task-list-item ' + this.props.className
      }), /*#__PURE__*/React.createElement("div", {
        contentEditable: false
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        checked: checked,
        onChange: this.onChange
      })), children);
    }
  }]);
  return CheckListItem;
}(React.PureComponent);
export default CheckListItem;